import { React, useState } from 'react';
import PropTypes from 'prop-types';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import ClientComplaintForm from './ClientComplaintForm';

// Bouton "Créer une réclamation" / "Créer un ticket" + formulaire partagé (mode création)
const ClientComplaintCreate = (props) => {
  const { user, update, setUpdate, getTickets, type } = props;
  const [open, setOpen] = useState(false);

  const handleSaved = () => {
    setUpdate(!update);
    if (getTickets) getTickets();
  };

  return (
    <>
      <Button
        color="primary"
        startIcon={<AddIcon fontSize="small" />}
        variant="contained"
        onClick={() => setOpen(true)}
      >
        {type === 'ticket' ? 'Créer un ticket' : 'Créer une réclamation'}
      </Button>

      <ClientComplaintForm
        open={open}
        onClose={() => setOpen(false)}
        mode="create"
        user={user}
        type={type}
        onSaved={handleSaved}
      />
    </>
  );
};

ClientComplaintCreate.propTypes = {
  user: PropTypes.object.isRequired,
  update: PropTypes.bool.isRequired,
  setUpdate: PropTypes.func.isRequired,
  getTickets: PropTypes.func,
  type: PropTypes.oneOf(['complaint', 'ticket'])
};

ClientComplaintCreate.defaultProps = {
  type: 'complaint'
};

export default ClientComplaintCreate;
